/* SCENT & SILK Signature 3.0.
   A local, editorial scent finder. No cookies, analytics, storage or external requests.
   Real purchasing remains entirely in Shopify's product and cart forms. */
(() => {
  'use strict';
  const root = document.documentElement;
  const byId = id => document.getElementById(id);
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const catalog = [
    ['australian-sandelholz', 'Australian Sandelholz'],
    ['indonesian-patchouli', 'Indonesian Patchouli'],
    ['cote-d-amalfi-bergamotte', 'Côte d’Amalfi Bergamotte'],
    ['egyptian-rose', 'Egyptian Rose'],
    ['brazilian-vanille', 'Brazilian Vanille'],
    ['kashmir-gold-safran', 'Kashmir Gold Safran'],
    ['monaco-blanc-cashmere', 'Monaco Blanc Cashmere']
  ];
  // Provisional merchandising weights inferred only from the supplied scent names.
  // Verify these against approved supplier scent profiles before public launch.
  const questions = [
    {title:'Welche Duftwelt spricht dich an?',desc:'Folge deinem ersten Gefühl.',answers:[
      ['Holzig & charaktervoll','Du magst die Idee von Holz und erdigen Duftwelten.',[6,6,0,0,1,2,1]],
      ['Blumig & elegant','Du denkst an eine Welt voller Blüten.',[0,0,0,8,1,1,2]],
      ['Frisch & sonnig','Zitrus und helle Duftmomente sprechen dich an.',[0,0,9,1,0,0,1]],
      ['Warm & umhüllend','Du magst die Idee von Vanille, Safran und Cashmere.',[1,1,0,0,5,5,5]]
    ]},
    {title:'Welcher Stil passt zu dir?',desc:'Es gibt keine richtige oder falsche Antwort.',answers:[
      ['Klar & zurückhaltend','Du liebst ein ruhiges, reduziertes Gefühl.',[2,0,3,1,1,0,5]],
      ['Ausdrucksstark & besonders','Dein Stil darf Charakter haben.',[2,4,0,1,0,5,0]],
      ['Sanft & vertraut','Du fühlst dich in einer weichen, vertrauten Welt wohl.',[1,0,0,3,5,0,4]]
    ]},
    {title:'Welchen Moment möchtest du gestalten?',desc:'Wähle die Szene, die dir am besten gefällt.',answers:[
      ['Ein heller Start in den Tag','Licht, Leichtigkeit und ein frischer Anfang.',[0,0,4,3,0,0,1]],
      ['Ein besonderer Abend','Atmosphäre, Charakter und ein eigener Stil.',[3,4,0,1,1,4,0]],
      ['Ein ruhiger Moment zu Hause','Wärme, Geborgenheit und Zeit für dich.',[1,0,0,1,4,2,4]]
    ]}
  ];
  let answers=[], step=0, origin=null;
  const getCard = handle => Array.from(document.querySelectorAll('.ss-product-card')).find(c=>c.dataset.ssHandle===handle);
  function openQuiz(trigger){
    const d=byId('svQuiz'); if(!(d instanceof HTMLDialogElement)) return;
    origin=trigger; answers=[]; step=0;
    document.querySelectorAll('dialog[open]').forEach(x=>x.close());
    document.querySelectorAll('.ss-mobile-menu[open], .ss-desktop-subnav[open]').forEach(x=>x.open=false);
    renderQuestion();d.showModal();document.body.classList.add('ss-dialog-open');
    d.querySelector('.sv-quiz-option')?.focus({preventScroll:true});
  }
  function renderQuestion(){
    const q=questions[step], list=byId('svQuizOptions');if(!list)return;
    byId('svQuizResult').hidden=true;list.hidden=false;list.replaceChildren();
    byId('svQuizCount').textContent=`Frage ${step+1} von ${questions.length}`;
    byId('svQuizTitle').textContent=q.title;byId('svQuizDescription').textContent=q.desc;
    document.querySelector('.sv-quiz-progress>span').style.width=`${(step+1)/questions.length*100}%`;
    byId('svQuizBack').textContent='Zurück';byId('svQuizBack').hidden=step===0;
    q.answers.forEach((a,index)=>{
      const b=document.createElement('button');b.type='button';b.className='sv-quiz-option';
      const title=document.createElement('strong');title.textContent=a[0];
      const text=document.createElement('span');text.textContent=a[1];b.append(title,text);
      b.addEventListener('click',()=>{answers[step]=index;if(step<questions.length-1){step++;renderQuestion();list.querySelector('button')?.focus({preventScroll:true});}else renderResult();});list.append(b);
    });
  }
  function renderResult(){
    const scores=catalog.map(()=>0);
    answers.forEach((a,qi)=>questions[qi].answers[a][2].forEach((value,i)=>scores[i]+=value));
    const ranked=catalog.map((x,i)=>({handle:x[0],name:x[1],score:scores[i]})).sort((a,b)=>b.score-a.score);
    const result=ranked[0], card=getCard(result.handle), panel=byId('svQuizResult');
    byId('svQuizOptions').hidden=true;byId('svQuizCount').textContent='Deine Duft-Inspiration';
    byId('svQuizTitle').textContent='Eine Duftwelt für dich.';
    byId('svQuizDescription').textContent='Aus deinen Antworten ergibt sich diese erste Inspiration.';
    byId('svQuizBack').hidden=false;byId('svQuizBack').textContent='Noch einmal starten';
    panel.replaceChildren();panel.hidden=false;
    const wrap=document.createElement('div');wrap.className='sv-quiz-result-inner';
    const source=card?.querySelector('.ss-product-photo');
    if(source){const img=document.createElement('img');img.src=source.currentSrc||source.src;img.alt=`${result.name} – Bildkonzept`;img.width=180;img.height=160;wrap.append(img);}
    const copy=document.createElement('div'),heading=document.createElement('h3'),p=document.createElement('p');
    heading.textContent=result.name;p.textContent='Entdecke diese Duftwelt. Die verbindliche Duftbeschreibung folgt auf der Produktseite.';
    copy.append(heading,p);
    const productLink=card?.querySelector('a.sv-card-art');
    const action=document.createElement(productLink?'a':'button');action.className='sv-button';action.textContent='DUFT ENTDECKEN →';
    if(productLink){action.href=productLink.href;}else{action.type='button';action.addEventListener('click',()=>{
      byId('svQuiz').close();const target=card?.querySelector('[data-ss-concept]');
      if(target)target.click();else window.location.href=(root.dataset.ssStandalone!==undefined?'':'/')+'#kollektion';
    });}
    copy.append(action);const note=document.createElement('p');note.className='sv-quiz-small';note.textContent='Eine gestalterische Orientierung, keine bestätigte Duftanalyse.';copy.append(note);
    wrap.append(copy);panel.append(wrap);action.focus({preventScroll:true});
  }
  document.addEventListener('click',event=>{
    if(!(event.target instanceof Element))return;
    const quiz=event.target.closest('[data-sv-quiz]');if(quiz){event.preventDefault();openQuiz(quiz);return;}
    const mobileButton=event.target.closest('.ss-mobile-menu button');if(mobileButton)mobileButton.closest('.ss-mobile-menu').open=false;
    if(event.target.closest('#svQuizBack')){
      if(byId('svQuizOptions').hidden){answers=[];step=0;}else step=Math.max(0,step-1);
      renderQuestion();byId('svQuizOptions').querySelector('button')?.focus({preventScroll:true});return;
    }
    const link=event.target.closest('a');if(!link)return;
    const href=link.getAttribute('href')||'';
    const match=href.match(/(?:^|\/)#duft-(.+)$/);
    if(match){
      const card=getCard(decodeURIComponent(match[1]));
      if(card){event.preventDefault();card.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'center'});card.classList.add('sv-flash');window.setTimeout(()=>card.classList.remove('sv-flash'),1300);}
    }
  });
  const d=byId('svQuiz');if(d)d.addEventListener('close',()=>{if(!document.querySelector('dialog[open]')){document.body.classList.remove('ss-dialog-open');if(origin instanceof HTMLElement)origin.focus({preventScroll:true});}});
})();
